import script from "./AppMaterialIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppMaterialIcon.vue?vue&type=script&lang=ts&setup=true"

import "./AppMaterialIcon.vue?vue&type=style&index=0&id=4b3eb93c&lang=scss&scoped=true"
script.__scopeId = "data-v-4b3eb93c"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
